import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkdownModule } from 'ngx-markdown';
import { trigger, state, style, animate, transition } from '@angular/animations';

@Component({
  selector: 'app-welcome-message',
  standalone: true,
  imports: [CommonModule, MarkdownModule],
  templateUrl: './welcome-message.component.html',
  styleUrls: ['./welcome-message.component.scss'],
  animations: [
    trigger('fadeIn', [
      state('in', style({ opacity: 1 })),
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-in', style({ opacity: 1 }))
      ])
    ])
  ]
})
export class WelcomeMessageComponent {
  @Input() visible = false;
  @Input() welcomeMessage = '';
  @Output() welcomeClick = new EventEmitter<MouseEvent>();

  handleWelcomeClick(event: MouseEvent): void {
    this.welcomeClick.emit(event);
  }
}